export enum FetchStatus {
    SUCCESS = 'success',
    NO_MORE_RESULTS = 'no-more-results',
    // Nothing was applied, but the cursor still points at pages worth requesting later.
    PAUSED = 'paused',
    CANCELED = 'canceled',
    ERROR = 'error',
    NO_CONVERSATION_SELECTED = 'no-conversation-selected',
}
